import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-premises-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-premises-ehms.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { MapService } from "../../../../../map/shared/map.service";
import { MapTools } from "../../../../../map/shared/map.tools";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ViewApplicationService } from "../../../view-application.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationPremisesEhmsConstants } from "./view-application-premises-ehms.consants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { phoneNumberValidator } from "../../../../../shared/classes/phone-number-validator";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { HttpClient } from "@angular/common/http";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { forkJoin } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationPremisesEhmsComponent = class ViewApplicationPremisesEhmsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    mapService;
    mapTools;
    http;
    appController;
    recipientListService;
    requestStatusService;
    changeDetectorRefs;
    viewApplicationService;
    active;
    propertiesForm;
    application;
    descriptionLabel1 = ViewApplicationPremisesEhmsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationPremisesEhmsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationPremisesEhmsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationPremisesEhmsConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationPremisesEhmsConstants.VALIDATION_MESSAGES;
    nameControl = ViewApplicationPremisesEhmsConstants.NAME_CONTROL;
    addressControl = ViewApplicationPremisesEhmsConstants.ADDRESS_CONTROL;
    postalAddressControl = ViewApplicationPremisesEhmsConstants.POSTAL_ADDRESS_CONTROL;
    telephoneControl = ViewApplicationPremisesEhmsConstants.TELEPHONE_CONTROL;
    emailControl = ViewApplicationPremisesEhmsConstants.EMAIL_CONTROL;
    faxControl = ViewApplicationPremisesEhmsConstants.FAX_CONTROL;
    cellphoneControl = ViewApplicationPremisesEhmsConstants.CELLPHONE_CONTROL;
    premisesTypeControl = ViewApplicationPremisesEhmsConstants.PREMISES_TYPE_CONTROL;
    ownerControl = ViewApplicationPremisesEhmsConstants.OWNER_CONTROL;
    contactsControl = ViewApplicationPremisesEhmsConstants.CONTACTS_CONTROL;
    nameTextPlaceHolder = ViewApplicationPremisesEhmsConstants.NAME_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationPremisesEhmsConstants.ADDRESS_TEXT_PLACEHOLDER;
    postalAddressTextPlaceHolder = ViewApplicationPremisesEhmsConstants.POSTAL_ADDRESS_TEXT_PLACEHOLDER;
    telephoneTextPlaceHolder = ViewApplicationPremisesEhmsConstants.TELEPHONE_TEXT_PLACEHOLDER;
    emailTextPlaceHolder = ViewApplicationPremisesEhmsConstants.EMAIL_TEXT_PLACEHOLDER;
    faxTextPlaceHolder = ViewApplicationPremisesEhmsConstants.FAX_TEXT_PLACEHOLDER;
    cellphoneTextPlaceHolder = ViewApplicationPremisesEhmsConstants.CELLPHONE_TEXT_PLACEHOLDER;
    premisesTypeTextPlaceHolder = ViewApplicationPremisesEhmsConstants.PREMISES_TYPE_TEXT_PLACEHOLDER;
    zoneLabel = ViewApplicationPremisesEhmsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = ViewApplicationPremisesEhmsConstants.ADD_ZONE_LABEL;
    ownerLabel = ViewApplicationPremisesEhmsConstants.OWNER_LABEL;
    contactsLabel = ViewApplicationPremisesEhmsConstants.CONTACTS_LABEL;
    copyApplicantToOwnerZoneLabel = ViewApplicationPremisesEhmsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    copyApplicantToContactsZoneLabel = ViewApplicationPremisesEhmsConstants.COPY_APPLICANT_TO_CONTACTS_LABEL;
    copyOwnerToContactsZoneLabel = ViewApplicationPremisesEhmsConstants.COPY_OWNER_TO_CONTACTS_LABEL;
    removePropertyLabel = ViewApplicationPremisesEhmsConstants.REMOVE_PROPERTY_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    contactsDisableFilterBy = true;
    contactsDisableAdd = false;
    contactsDisableEditing = false;
    contactsGroups = [];
    premisesServiceURL = ViewApplicationPremisesEhmsConstants.PREMISES_URL;
    sketch;
    ownerListLabel = "Owner";
    zones = [];
    premisesTypes = [];
    mapComponent;
    isMapLoaded = false;
    getApplicationObservableSubscription;
    getPremisesQuerySubscription;
    selectedPremisesSubscription;
    getApplicationSaveApplicantObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, mapService, mapTools, http, appController, recipientListService, requestStatusService, changeDetectorRefs, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.http = http;
        this.appController = appController;
        this.recipientListService = recipientListService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.viewApplicationService = viewApplicationService;
    }
    // TODO: @Lawrence - on save premises:update each premises using EHPremisesController.Patch
    // and then call EHApplication/AppId/SetMultipleEHPremises (new method Michael is writing) with of list of premiseids
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        this.premisesTypes = [];
        if (this.aflaModuleStrategyService.lookups.has("PremisesType")) {
            this.premisesTypes = this.aflaModuleStrategyService.lookups.get("PremisesType");
        }
        else {
            this.getLookups();
        }
        this.changeDetectorRefs.detectChanges();
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.contactsGroups = stepMeta.contactGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and name eq 'PremisesType'`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationPremisesEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const premisesTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PremisesType") {
                    premisesTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("PremisesType", premisesTypes);
        this.premisesTypes = premisesTypes;
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        const propertyControl = this.getProperties();
        propertyControl.clear();
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.sketch.on("create", (event) => {
            if (event.state === "start") {
                this.mapService.showPopups = false;
            }
            if (event.state === "complete") {
                this.mapService.showPopups = true;
                if (event.graphic.geometry.type === "point") {
                    this.setPropertyData(null, event.graphic.geometry);
                }
            }
            else if (event.state === "cancel") {
                this.mapService.showPopups = true;
            }
            else {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
    }
    getProperties() {
        return this.propertiesForm.get("premises");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const nameControl = propertyControl.get(this.nameControl);
        const addressControl = propertyControl.get(this.addressControl);
        const postalAddressControl = propertyControl.get(this.postalAddressControl);
        if (nameControl.value !== undefined && nameControl.value !== null && nameControl.value.trim() !== "") {
            nameControl.setValidators(Validators.required);
            addressControl.clearValidators();
            postalAddressControl.clearValidators();
        }
        else if ((addressControl.value !== undefined && addressControl.value !== null && addressControl.value.trim() !== "") ||
            (postalAddressControl.value !== undefined && postalAddressControl.value !== null && postalAddressControl.value.trim() !== "")) {
            nameControl.clearValidators();
            addressControl.setValidators(Validators.required);
            postalAddressControl.setValidators(Validators.required);
        }
        else {
            nameControl.setValidators(Validators.required);
            addressControl.setValidators(Validators.required);
            postalAddressControl.setValidators(Validators.required);
        }
        nameControl.updateValueAndValidity();
        addressControl.updateValueAndValidity();
        postalAddressControl.updateValueAndValidity();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToContactsClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("contacts");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyOwnerToContactsClicked(propertyIndex) {
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        const ownersList = ownersFormControl.value ? ownersFormControl.value.recipients : [];
        const contactsFormControl = this.getProperties().controls[propertyIndex].get("contacts");
        const contactsList = contactsFormControl.value ? contactsFormControl.value.recipients : [];
        ownersList.forEach((item) => {
            if (item.selected) {
                contactsList.push(item);
            }
        });
        this.recipientListService.setRecipients(contactsList, true, contactsFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("premisesForm");
        this.getCurrentApplication();
    }
    getCurrentApplication() {
        const propertyControl = this.getProperties();
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `premises`
        };
        this.getApplicationObservableSubscription = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params).subscribe({
            next: response => {
                if (response && response.value.length > 0 && response.value[0].premises.length > 0) {
                    this.application = response.value[0];
                    if (propertyControl.length === 0) {
                        for (const prem of response.value[0].premises) {
                            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(prem.shape, 102100);
                            const geom = JsonUtils.fromJSON(geometryArc);
                            const newPremises = new FormGroup({
                                id: new FormControl(prem.id),
                                name: new FormControl(prem.name, [Validators.required]),
                                address: new FormControl(prem.address, [Validators.required]),
                                postalAddress: new FormControl(prem.postalAddress, [Validators.required]),
                                telephone: new FormControl(prem.telephone, [Validators.required, phoneNumberValidator]),
                                email: new FormControl(prem.email, [Validators.email]),
                                fax: new FormControl(prem.fax, [phoneNumberValidator]),
                                cellphone: new FormControl(prem.cellphone, [phoneNumberValidator]),
                                premiseType: new FormControl(prem.premiseType),
                                moduleId: new FormControl(prem.moduleId),
                                geometry: new FormControl(geom),
                                owners: new FormControl(null),
                                contacts: new FormControl(null)
                            });
                            this.getPremisesOwners(prem.id, newPremises);
                        }
                    }
                }
                else {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                }
            },
            error: error => {
                this.appController.handleServerErrorMessage(ViewApplicationPremisesEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    getMetadata() {
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        if (propertyObject) {
            const newPremises = new FormGroup({
                id: new FormControl(propertyObject.Id),
                name: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Name", "name"), [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                postalAddress: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PostalAddress", "portalAddress"), [Validators.required]),
                telephone: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TelephoneNumber", "telephoneNumber"), [Validators.required, phoneNumberValidator]),
                email: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Email", "email"), [Validators.email]),
                fax: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Fax", "fax"), [phoneNumberValidator]),
                cellphone: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Cellphone", "cellphone"), [phoneNumberValidator]),
                premiseType: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PremisesType", "premisesType")),
                moduleId: new FormControl(propertyObject.ModuleId),
                geometry: new FormControl(geometry),
                owners: new FormControl({ IRecipient: [] }),
                contacts: new FormControl({ IRecipient: [] })
            });
            this.getPropertyOwners(propertyObject.Id, newPremises);
        }
        else {
            const newPremises = new FormGroup({
                id: new FormControl(0),
                name: new FormControl(null, [Validators.required]),
                address: new FormControl(null, [Validators.required]),
                postalAddress: new FormControl(null, [Validators.required]),
                telephone: new FormControl(null, [Validators.required, phoneNumberValidator]),
                email: new FormControl(null, [Validators.email]),
                fax: new FormControl(null, [phoneNumberValidator]),
                cellphone: new FormControl(null, [phoneNumberValidator]),
                premiseType: new FormControl(null),
                moduleId: new FormControl(Number(this.appController.selectedModuleID)),
                geometry: new FormControl(geometry),
                owners: new FormControl({ IRecipient: [] }),
                contacts: new FormControl({ IRecipient: [] })
            });
            this.getPropertyOwners(null, newPremises);
        }
    }
    getPremisesQuery(params) {
        return this.http.get(this.premisesServiceURL, { params });
    }
    getPremisesOwners(id, newPremises) {
        const params = {
            $expand: "owners, contacts",
            $filter: `id eq ${id}`
        };
        this.getPremisesQuerySubscription = this.getPremisesQuery(params).subscribe({
            next: (response) => {
                const premisesOwners = response.value[0].owners;
                const premisesContacts = response.value[0].contacts;
                const ownersControl = newPremises.get("owners");
                const contactsControl = newPremises.get("contacts");
                const owners = [];
                const contacts = [];
                premisesOwners.forEach(item => {
                    try {
                        const newOwner = {
                            id: item.id,
                            name: item.name,
                            surname: item.surname,
                            telephone: item.telephone,
                            email: item.email,
                            defaultCommunicationMethod: item.DefaultCommunicationMethod,
                            postalAddress: item.postalAddress,
                            designation: item.designation,
                            organisation: item.organisation,
                            clientVatNumber: item.clientVatNumber,
                            streetAddress: item.streetAddress,
                            homePhone: item.homePhone,
                            idNumber: item.idNumber,
                            organisationRegistrationNumber: item.organisationRegistrationNumber,
                            representative: item.representative,
                            fax: item.fax,
                            cellphone: item.cellphone,
                            streetSuburb: item.streetSuburb,
                            streetCity: item.streetCity,
                            streetProvince: item.streetProvince,
                            streetCode: item.streetCode,
                            postalSuburb: item.postalSuburb,
                            postalCity: item.postalCity,
                            postalProvince: item.postalProvince,
                            postalCode: item.postalCode,
                            postalCountry: item.postalCountry,
                            streetCountry: item.streetCountry,
                            professionalBody: item.professionalBody,
                            professionalBodyRegNum: item.professionalBodyRegNum,
                            groups: []
                        };
                        owners.push(newOwner);
                    }
                    catch {
                        this.appController.showMessage(ViewApplicationPremisesEhmsConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                    }
                }, (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.showMessage(error.message, AlertType.Error);
                });
                premisesContacts.forEach(item => {
                    try {
                        const newContact = {
                            id: item.id,
                            name: item.name,
                            surname: item.surname,
                            telephone: item.telephone,
                            email: item.email,
                            defaultCommunicationMethod: item.DefaultCommunicationMethod,
                            postalAddress: item.postalAddress,
                            designation: item.designation,
                            organisation: item.organisation,
                            clientVatNumber: item.clientVatNumber,
                            streetAddress: item.streetAddress,
                            homePhone: item.homePhone,
                            idNumber: item.idNumber,
                            organisationRegistrationNumber: item.organisationRegistrationNumber,
                            representative: item.representative,
                            fax: item.fax,
                            cellphone: item.cellphone,
                            streetSuburb: item.streetSuburb,
                            streetCity: item.streetCity,
                            streetProvince: item.streetProvince,
                            streetCode: item.streetCode,
                            postalSuburb: item.postalSuburb,
                            postalCity: item.postalCity,
                            postalProvince: item.postalProvince,
                            postalCode: item.postalCode,
                            postalCountry: item.postalCountry,
                            streetCountry: item.streetCountry,
                            professionalBody: item.professionalBody,
                            professionalBodyRegNum: item.professionalBodyRegNum,
                            groups: []
                        };
                        contacts.push(newContact);
                    }
                    catch {
                        this.appController.showMessage(ViewApplicationPremisesEhmsConstants.INVALID_CONTACT_ATTRIBUTE, AlertType.Error);
                    }
                }, (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.showMessage(error.message, AlertType.Error);
                });
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newPremises);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl, false);
                }
                if (contacts.length > 0) {
                    this.recipientListService.setRecipients(contacts, true, contactsControl, false);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
            }
        });
    }
    getPropertyOwners(premisesId, newPremises) {
        if (premisesId) {
            this.getPremisesOwners(premisesId, newPremises);
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newPremises);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            if (item.get("geometry")) {
                const geom = item.get("geometry").value;
                if (geom !== null) {
                    geometries.push(geom);
                }
            }
            else if (item.get("shape")) {
                const geom = item.get("shape").value;
                if (geom !== null) {
                    geometries.push(geom);
                }
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Premises graphics", true);
        }
    }
    subscribeToProperty() {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        this.selectedPremisesSubscription = this.mapService.$selectedPremises.subscribe(premises => {
            if (premises !== null) {
                this.setPropertyData(premises.attributes, premises.geometry);
            }
        });
    }
    onButtonSaveClicked() {
        if (this.propertiesForm.valid) {
            const properties = [];
            const propertiesArray = this.getProperties();
            for (const item of propertiesArray.controls) {
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                const owners = item.get("owners").value && item.get("owners").value.recipients ? item.get("owners").value.recipients : [];
                if (owners.length > 0) {
                    owners.forEach((owner) => {
                        owner = RecipientUtils.removeRecipientProperties(owner);
                    });
                }
                const contacts = item.get("contacts").value && item.get("contacts").value.recipients ? item.get("contacts").value.recipients : [];
                if (contacts.length > 0) {
                    contacts.forEach((contact) => {
                        if (contact.moduleId) {
                            delete contact.moduleId;
                        }
                        contact = RecipientUtils.removeRecipientProperties(contact);
                    });
                }
                const premises = {
                    id: item.get("id").value,
                    address: item.get("address").value,
                    cellphone: item.get("cellphone").value,
                    email: item.get("email").value,
                    fax: item.get("fax").value,
                    moduleId: item.get("moduleId").value,
                    name: item.get("name").value,
                    owners,
                    contacts,
                    shape: geometryJSON,
                    wkid: 102100,
                    postalAddress: item.get("postalAddress").value,
                    premiseType: item.get("premiseType").value,
                    telephone: item.get("telephone").value,
                };
                properties.push(premises);
            }
            const observables = [];
            for (const item of properties) {
                const premisesId = item.id;
                if (item.id !== 0) {
                    delete item.id;
                    delete item.moduleId;
                }
                const observable = premisesId !== 0 ? this.viewApplicationService.getApplicationSaveObservable(this.premisesServiceURL, premisesId, item) : this.viewApplicationService.getApplicationSavePremisesObservable(this.premisesServiceURL, item);
                observables.push(observable);
            }
            forkJoin(observables).subscribe(results => {
                const premisesIds = results.map(premises => premises.id);
                const primisesIdList = {
                    ehPremisesIdList: premisesIds
                };
                this.getApplicationSaveApplicantObservableSubscription = this.viewApplicationService.getApplicationSaveApplicantObservable(this.aflaModuleStrategyService.applicationServiceUrl, "SetEHPremisesMultiple", this.application.id, primisesIdList)
                    .subscribe(response => {
                    this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    this.getCurrentApplication();
                }, error => {
                    this.appController.handleServerErrorMessage(ViewApplicationPremisesEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
                });
            });
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: MapService },
        { type: MapTools },
        { type: HttpClient },
        { type: AppControllerService },
        { type: RecipientListService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationPremisesEhmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-premises-ehms",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationPremisesEhmsComponent);
export { ViewApplicationPremisesEhmsComponent };
